// components/StartDivorceForm.tsx
import React, { useState } from "react";
import { usaStatesWithCounties } from "typed-usa-states";
import { Button } from "../../../../../design/button";
import { Field, Label } from "../../../../../design/fieldset";
import { Select } from "../../../../../design/select";
import OnboardingContainer from "../../../components/OnboardingContainer";
import { Intake } from "../../../../../models/Intake";

const OnboardingEligibilityStep: React.FC<{
  formData: Omit<
    Intake,
    "_id" | "createdAt" | "updatedAt" | "createdBy" | "updatedBy" | "status"
  >;
  setFormData: React.Dispatch<
    React.SetStateAction<
      Omit<
        Intake,
        "_id" | "createdAt" | "updatedAt" | "createdBy" | "updatedBy" | "status"
      >
    >
  >;
  onBack: () => void;
  onStepComplete: () => void;
}> = ({ formData, setFormData, onBack, onStepComplete }) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onStepComplete();
  };

  return (
    <OnboardingContainer
      title="Welcome To CaseTime!"
      subtitle="Sorry you are here, but we are glad you found us."
    >
      <>
        <p className="mb-6 text-gray-700">
          To begin, we'll need some information about your relationship.
        </p>
        <form onSubmit={handleSubmit} className="space-y-6">
          <Field>
            <Label>* Your state of Residence:</Label>
            <Select
              value={formData.residenceState}
              onChange={(e) =>
                setFormData({ ...formData, residenceState: e.target.value })
              }
            >
              {usaStatesWithCounties.map((s) => (
                <option key={s.abbreviation} value={s.abbreviation}>
                  {s.name}
                </option>
              ))}
            </Select>
          </Field>

          {formData.residenceState && (
            <Field>
              <Label>
                * Confirm the county where you are filing for divorce
              </Label>
              <Select
                value={formData.residenceCounty}
                onChange={(e) =>
                  setFormData({ ...formData, residenceCounty: e.target.value })
                }
              >
                {(
                  usaStatesWithCounties.find(
                    (s) => s.abbreviation === formData.residenceState,
                  )?.counties || []
                ).map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </Select>
            </Field>
          )}

          <Button type="submit" className="w-full">
            Continue
          </Button>
        </form>
      </>
    </OnboardingContainer>
  );
};

export default OnboardingEligibilityStep;
